















import Vue from 'vue'

export default Vue.extend({
  name: 'custom-section',
  props: {
    section: {
      type: Object,
      required: true,
    }
  },
  data() {
    return {
      collapsed: false
    }
  },
  methods: {
    toggleCollapsed() {
      this.collapsed = !this.collapsed
    }
  }
})
